export enum ClaimCustomForm {
  UpdatePatient = 'AssociatePatientEOC',
  InitialComplete = 'CompleteWithContractTBD',
  FinalComplete = 'CompleteClaim',
  MarkAsAppeal = 'MarkAsAppeal',
  AssignToEntryUserAndSend = 'AssignToEntryUserAndSend',
  SendToOcr = 'SendToOcr',
  ProcessRefund = 'ProcessRefund',
  ProviderOverpaidAppealCompleteClaim = 'ProviderOverpaidAppealCompleteClaim',
}
